import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { FaArrowRight, FaShieldAlt, FaRobot, FaChartLine, FaClipboardList } from 'react-icons/fa';
import PageNavbar from './PageNavbar';
import Footer from './Footer';
import { defaultViewport, staggerContainer, staggerItem, getRevealProps } from '../motion/scrollMotion';
import './ContentPages.css';

const tools = [
  {
    icon: <FaShieldAlt />,
    tag: 'NIST CSF 2.0',
    title: 'NIST CSF 2.0 Maturity Assessment',
    desc: 'Sixteen questions across the six CSF 2.0 Functions — Govern, Identify, Protect, Detect, Respond, Recover. Get an indicative Implementation Tier and where to focus first.',
    href: '/nist-csf-assessment',
  },
  {
    icon: <FaRobot />,
    tag: 'NIST AI RMF',
    title: 'NIST AI RMF Readiness Assessment',
    desc: 'Fourteen questions across Govern, Map, Measure, and Manage — an indicative readiness level for managing AI risk responsibly and closing the biggest gaps.',
    href: '/nist-ai-rmf-assessment',
  },
  {
    icon: <FaChartLine />,
    tag: 'Security Program',
    title: 'Security Maturity Assessment',
    desc: 'Twelve questions across six domains — governance, identity, detection, response, data protection, and vendor risk — for a real breakdown of where your program stands.',
    href: '/security-maturity-assessment',
  },
  {
    icon: <FaClipboardList />,
    tag: 'Quick Check',
    title: 'Cyber Risk Snapshot',
    desc: 'A fast risk snapshot to surface the gaps most likely to hurt you, and the highest-leverage places to start.',
    href: '/risk-assessment',
  },
];

const FreeToolsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="content-page">
      <PageNavbar />

      <section className="content-hero">
        <div className="content-hero-glow" />
        <motion.div className="content-hero-inner" {...getRevealProps('fadeUp')}>
          <span className="content-badge">Free Tools</span>
          <h1 className="content-hero-title">Free Security &amp; AI Assessments.</h1>
          <p className="content-hero-desc">
            Short, framework-aligned self-assessments you can run in about five minutes. Each gives
            you an indicative maturity level and a per-area breakdown — a practical starting point,
            based only on the information you provide, not a formal audit.
          </p>
        </motion.div>
      </section>

      <section className="content-section">
        <motion.div
          className="content-grid"
          initial="hidden"
          whileInView="visible"
          viewport={defaultViewport}
          variants={staggerContainer}
        >
          {tools.map((t) => (
            <motion.div className="content-card" key={t.href} variants={staggerItem}>
              <div className="content-card-icon">{t.icon}</div>
              <div className="content-meta">{t.tag}</div>
              <h3 className="content-card-title">{t.title}</h3>
              <p className="content-card-desc">{t.desc}</p>
              <Link to={t.href} className="content-card-link">
                Start assessment <FaArrowRight />
              </Link>
            </motion.div>
          ))}
        </motion.div>

        <p className="content-fineprint">
          Results are indicative and based solely on your self-reported answers — they are not an
          audit, certification, or validated assessment. For a hands-on review,{' '}
          <Link to="/contact">talk to our team</Link>.
        </p>
      </section>

      <Footer />
    </div>
  );
};

export default FreeToolsPage;
